import type { ExternalDelivery } from './store/types'

/** Handover на точке выдачи (source / with_confirmation). */
export function getSourceHandoverStatus(ext: ExternalDelivery | null | undefined): string | null {
  const items = ext?.routePointsSnapshot?.handover?.items
  if (!items?.length) {
    return null
  }
  const source = items.find((h) => h.type === 'with_confirmation')
  return source?.status ?? null
}

export function isSourceHandoverExchanging(ext: ExternalDelivery | null | undefined): boolean {
  return getSourceHandoverStatus(ext) === 'exchanging'
}
